import { render } from "./SpiritOfJapan6.vue?vue&type=template&id=8f76989c&scoped=true"
import script from "./SpiritOfJapan6.vue?vue&type=script&lang=js"
export * from "./SpiritOfJapan6.vue?vue&type=script&lang=js"

import "./SpiritOfJapan6.scss?vue&type=style&index=0&id=8f76989c&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f76989c"]])

export default __exports__